import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'
import DatePicker from 'react-datepicker'
import dayjs from 'dayjs'
import 'react-datepicker/dist/react-datepicker.css'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

import { FormGroup } from '@peracto/peracto-ui'

const StyledDateInput = styled.div`
    .full-width-wrapper {
        .react-datepicker-wrapper {
            display: block;
            width: 100%;
        }
    }
`

const DateInput = ({
    name,
    label = '',
    help,
    className,
    showWhen,
    required = null,
    defaultValue,
    rawDate = false,
    setTime,
    format,
    allowClear = false,
    fullWidth = false,
    includeTime = false,
    disabled,
    ...props
}) => {
    return (
        <StyledDateInput>
            <Field name={name}>
                {({ field, form }) => {
                    let error = getIn(form.errors, name)

                    if (error) {
                        const errorFieldName = label ? label : 'This'
                        error = error.replace(field.name, errorFieldName)
                    }

                    if (showWhen) {
                        const showField = form.values.hasOwnProperty(showWhen)
                            ? form.values[showWhen]
                            : false

                        if (!showField) {
                            return null
                        }
                    }

                    props.className = classNames('form-control', className)

                    if (help) {
                        props['aria-describedby'] = `${name}Help`
                    }

                    return (
                        <FormGroup {...{ name, label, help, required }} error={error}>
                            <div
                                className={classNames({
                                    'full-width-wrapper': fullWidth,
                                    '!flex !flex-row': allowClear,
                                })}
                            >
                                <DatePicker
                                    className={`datepicker__start-date form-control ${className}`}
                                    placeholderText="Select Date..."
                                    selected={
                                        rawDate
                                            ? field.value
                                            : field.value
                                            ? new Date(field.value)
                                            : allowClear
                                            ? ''
                                            : new Date()
                                    }
                                    dateFormat={
                                        format || (includeTime ? `dd/MM/yyyy HH:mm` : `dd/MM/yyyy`)
                                    }
                                    showTimeSelect={includeTime}
                                    timeFormat="HH:mm"
                                    timeCaption="Time"
                                    onChange={date => {
                                        if (date) {
                                            if (setTime) {
                                                date = setTime(date)
                                            }
                                            if (rawDate) {
                                                form.setFieldValue(field.name, date)
                                            } else {
                                                form.setFieldValue(
                                                    field.name,
                                                    dayjs(includeTime ? date : date.toDateString())
                                                )
                                            }
                                        } else {
                                            form.setFieldValue(field.name, null)
                                        }
                                    }}
                                    {...props}
                                />

                                {allowClear && (
                                    <button
                                        className="btn btn-link !whitespace-nowrap"
                                        onClick={e => {
                                            e.preventDefault()
                                            form.setFieldValue(field.name, '')
                                        }}
                                        disabled={form.isSubmitting || disabled}
                                    >
                                        <FontAwesomeIcon icon={faTimes} className="!mr-2" />
                                        Clear Value
                                    </button>
                                )}
                            </div>
                        </FormGroup>
                    )
                }}
            </Field>
        </StyledDateInput>
    )
}

DateInput.displayName = 'DateInput'

DateInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    showWhen: PropTypes.string,
}

export default DateInput
